import { Either, fetchData, right, TaskEither, taskEither } from '@shared-commons/utils';
import { CatalogViewData } from '../types/catalog-view-data';

export const catalogViewService = (): TaskEither<Error, { data: CatalogViewData }> => {
  const adapter = (input: any): TaskEither<Error, { data: CatalogViewData }> => {
    return taskEither(async () => right(input as { data: CatalogViewData }));
  };

  const validate = (_data: { data: CatalogViewData }): Either<Error, { data: CatalogViewData }> => {
    return right(_data);
  };

  return fetchData<{ data: CatalogViewData }>(
    `${process.env.NEXT_PUBLIC_HOST}/api/catalog/view`,
    adapter,
    validate,
    'GET',
    {},
  );
};

// New function to get only essential catalog data
export const getEssentialCatalogData = (): TaskEither<Error, { data: CatalogViewData }> => {
  const adapter = (input: any): TaskEither<Error, { data: CatalogViewData }> => {
    return taskEither(async () => right(input as { data: CatalogViewData }));
  };

  const validate = (_data: { data: CatalogViewData }): Either<Error, { data: CatalogViewData }> => {
    return right(_data);
  };

  return fetchData<{ data: CatalogViewData }>(
    `${process.env.NEXT_PUBLIC_HOST}/api/catalog/view/essential`,
    adapter,
    validate,
    'GET',
    {},
  );
};

// Export both functions in an object for better import structure
catalogViewService.getEssentialCatalogData = getEssentialCatalogData;
